'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

AddressValidatorController=class AddressValidatorController{
static get $inject(){return['$scope','socketService','$timeout']}

constructor($scope,socketService,$timeout){
this._socketService=socketService;
this._$timeout=$timeout;

this._inputId=Guid.create().toString();

this.isValid=!0;
this.errorMessage='';

this._debouncedValidate=_.debounce(this._validate,500);

$scope.$watch('controller.address',newAddress=>{
this._debouncedValidate(newAddress);
});
}

get inputId(){
return this._inputId;
}

_updateValidity(isValid,errorMessage){
this._$timeout(()=>{
this.isValid=isValid;
this.errorMessage=errorMessage;
});
}

async _validate(address){
if(!_.exists(address)||address.length===0){
this._updateValidity(!1,'Please enter an address.');
return;
}else if(address.split(/\s+/g).length<2){
this._updateValidity(!1,'Please enter a valid address.');
return;
}

let validationResponse=await this._socketService.sendAndWaitForResponse('ValidateAddress',address);

this._updateValidity(validationResponse.valid,validationResponse.message);
}};let


AddressValidatorDirective=class AddressValidatorDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/addressValidatorDirective/addressValidatorTemplate'}
get objectBindings(){return['address','form']}
get controller(){return AddressValidatorController}};


module.exports=AddressValidatorDirective;
//# sourceMappingURL=addressValidatorDirective.js.map
